import React, { useState, useEffect, use } from 'react';
import { Table, Button, Input, Space, Drawer, AutoComplete, message, Modal , Select, Form, Checkbox} from 'antd';
import { EditOutlined, DeleteOutlined, UserAddOutlined } from '@ant-design/icons';
import { FaUser, FaEnvelope, FaLock } from "react-icons/fa";
import * as XLSX from 'xlsx';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import axios from '../../services/axios';
import { CONTRACTOR, CONSULTANT, EMPLOYER, SUBCONTRACTOR, NOMINATED_SUBCONTRACTOR, SPECIALIST_SUBCONTRACTOR, VENDOR, PROJECT_MANAGEMENT_CONSULTANT, } from '../../constants/userType';

const { Option } = Select;

const ManageUsers = () => {
  const [form] = Form.useForm();
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [isEditUser, setISEditUser] = useState(false);
  const [tableData, setTableData] = useState([]);
	const [filters, setFilters] = useState([]);
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [projectNames, setProjectNames] = useState([]);
  const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%^#%*?&])[A-Za-z\d@$!%^%#*?&]{8,}$/;
  const user = localStorage.getItem('user');
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [documentCategories, setDocumentCategories] = useState([])
  const [loading, setLoading] = useState(true);
  const [selectedUserType, setSelectedUserType] = useState(null);

  const filteredRoles = roles.filter(
    (r) => r.userType === selectedUserType
  );

  const getRoles = async () => {
    try {
      setLoading(true);
			const res = await axios.get('get-all-roles');
			if (res && res.data && res.data.roles && res.data.roles) {
				setRoles(res.data.roles);
			}
		} catch (err) {
			if (err.response && err.response.data && err.response.data.msg) {
				message.warning(err.response.data.msg);
			} else if (err.response && err.response.data && err.response.data.userName) {
				message.warning(err.response.data.userName[0]);
			} else if (err.response && err.response.status === 401) {
				message.error('User not authorised');
			} else {
				message.error('Something went wrong');
			}
		} finally {
      setLoading(false);
    }
  }

   const handleDeleteUser = async (code) => {

    Modal.confirm({
      title: "Are you sure you want to delete this user?",
      // content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          const response = await axios.post(`delete-user`, {code});

  
          if (response.status === 200) {
            message.success('User Deleted Successfully');
  
            // Update state to remove the deleted user
            setTableData((prevUsers) => prevUsers.filter(user => user.code !== code));
          }
        } catch (err) {
          if (err.response && err.response.data && err.response.data.msg) {
                 message.warning(err.response.data.msg);
               } else if (err.response && err.response.data && err.response.data.userName) {
                 message.warning(err.response.data.userName[0]);
               } else if (err.response && err.response.status === 401) {
                 message.error('User not authorized');
               } else {
                 message.error('Something went wrong');
               }
        }
      },
    });
  };
  
  const handleAddOrEditUser = async (values) => {  
    // Validate password only for new users
    if (!editingUser) {
      if (!passwordPattern.test(values.password)) {
        setPasswordError('Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and be at least 8 characters long.');
        return;
      }
      if (values.password !== values.confirmPassword) {
        setConfirmPasswordError('Password and Confirm Password do not match.');
        return;
      }
    }
  
    try {
  
      if (isEditUser) {
        values.code = editingUser.code;
        values.username = editingUser.username;
        await axios.post('edit-user', values);
        message.success('User Updated Successfully');
      } else {
        values.user = user;
        const response = await axios.post('add-user', values);
        if (response.status === 200) {
          message.success('User Added Successfully');
        }
      }
      setISEditUser(false)
      getAllUsers();
  
      handleCloseDrawer();
    } catch (err) {
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong');
      }    }
  };
  

  const handleCloseDrawer = () => {
    setISEditUser(false)
      setPasswordError('');
      setConfirmPasswordError(''); 
      setEditingUser(null); 
      setIsDrawerVisible(false); 
      form.resetFields();
      setSelectedRole([])
  };

  const handleAddUser = () => {
    setEditingUser(null); 
    
    
    setPasswordError(''); 
    setConfirmPasswordError(''); 
    setIsDrawerVisible(true); 
  };

  useEffect(() => {
    getAllUsers();
    getRoles();
  }, []);

  const getDocumentTypes = async () => {
    try {
			const res = await axios.post('get-document-types', {selectedRole});
			if (res && res.data) {
				setDocumentTypes(res.data.documentTypes);
        setDocumentCategories(res.data.documentCategories)
			}
		} catch (err) {
			if (err.response && err.response.data && err.response.data.msg) {
				message.warning(err.response.data.msg);
			} else if (err.response && err.response.data && err.response.data.userName) {
				message.warning(err.response.data.userName[0]);
			} else if (err.response && err.response.status === 401) {
				message.error('User not authorised');
			} else {
				message.error('Something went wrong');
			}
		}
  }

 useEffect(() => {
      if (selectedRole) {
        getDocumentTypes(selectedRole); // Fetch projects when accountName is selected
      }
    }, [selectedRole]);
  
  const getAllUsers = async () => {
    try {
      setLoading(true);
      const res = await axios.post('get-all-user', {user});

      if(res.data?.users) {
        setTableData(res.data.users);
        const reformattedArray = res.data.users.map(({ username }) => ({ ['text']: username, ['value']: username }));
				const unique = [];
				reformattedArray.map(x => unique.filter(a => a.text === x.text && a.value === x.value).length > 0 ? null : unique.push(x));
				setFilters(unique);
      }

      if(res && res.data && res.data.project){
        setProjectNames(res.data.project)
      }

    } catch (err) {
       if (err.response && err.response.data && err.response.data.msg) {
              message.warning(err.response.data.msg);
            } else if (err.response && err.response.data && err.response.data.userName) {
              message.warning(err.response.data.userName[0]);
            } else if (err.response && err.response.status === 401) {
              message.error('User not authorized');
            } else {
              message.error('Something went wrong');
            }
    } finally {
      setLoading(false);
    }
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
    form.setFieldsValue(user);
    setISEditUser(true);
    setIsDrawerVisible(true);
  };

  const handleExport = () => {
    const filteredUsers = tableData.map(user => ({
      Username: user.username,
      FirstName: user.firstName,
      LastName: user.lastName,
      Email: user.email,
      PhoneNumber: user.phoneNumber,
      Role: user.role?.join(', '),
      Projects: user.projectName?.join(', '),
      CanUploadDocuments: user.canUploadDocuments ? 'Yes' : 'No',
      CanViewDocuments: user.canViewDocuments ? 'Yes' : 'No',
    }));

    const ws = XLSX.utils.json_to_sheet(filteredUsers);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users");
    XLSX.writeFile(wb, "User_Data.xlsx");
  };

  const columns = [
    { title: 'Username', dataIndex: 'username', key: 'username',
      filters: filters,
      onFilter: (value, record) => record.username.startsWith(value),
      filterSearch: true,
      ellipsis: true,
      width: 150,
    },
    { title: 'First Name', dataIndex: 'firstName', key: 'firstName', width: 150 },
    { title: 'Last Name', dataIndex: 'lastName', key: 'lastName', width: 150},
    { title: 'Email', dataIndex: 'email', key: 'email', width: 200, ellipsis: true },
    { title: 'Phone', dataIndex: 'phoneNumber', key: 'phoneNumber', width: 170 },
    { title: 'Role(s)', dataIndex: 'role', key: 'role', render: role => role?.join(', '), width: 200, ellipsis: true },
    { 
      title: 'Document Type', 
      dataIndex: 'documentType', 
      key: 'documentType', 
      render: (documentType) => documentType?.join(', ') || 'N/A', 
      width: 200, 
      ellipsis: true 
    },
    { 
      title: 'Document Category', 
      dataIndex: 'documentCategory', 
      key: 'documentCategory', 
      render: (documentCategory) => documentCategory?.join(', ') || 'N/A', 
      width: 250, 
      ellipsis: true
    },
    { title: 'User Type', dataIndex: 'userType', key: 'userType', width: 170 },
    {
      title: "Project Name",
      dataIndex: "projectName",
      key: "projectName",
      render: (projects) => projects?.join(", "), // Display array values as a string
      width: 200, ellipsis: true,
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 150,
      render: (_, user) => (
        <Space>
          <Button icon={<EditOutlined />} onClick={() => handleEditUser(user)} />
          <Button icon={<DeleteOutlined />} danger onClick={() => handleDeleteUser(user.code)} />
        </Space>
      ),
    },
  ];

  return (
    <div className="relative flex-1 p-5 overflow-y-auto ml-4 mr-1 min-h-screen">
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '1px' }}>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 className="text-3xl font-semibold text-gray-800 mb-6">User Management</h1>
          <Space>
            <Button type="primary" icon={<UserAddOutlined />} onClick={handleAddUser}>Add User</Button>
            <Button type="dashed" onClick={handleExport}>Export</Button>
          </Space>
        </div>

        {/* <Space style={{ marginBottom: 20 }}>
          <AutoComplete
            style={{ width: 250 }}
            options={users.map(user => ({ value: user.username }))}
            onChange={setSearchText}
            placeholder="Search users"
          >
            <Input.Search 
            value={searchText}
            onSearch={setSearchText} />
          </AutoComplete>
        </Space> */}

        <Table columns={columns} dataSource={tableData} rowKey="id" style={{ marginBottom: '20px' }} loading={loading} />

        <Drawer
          title={editingUser ? "Edit User" : "Add User"}
          placement="right"
          onClose={handleCloseDrawer}
          open={isDrawerVisible}
          width={590}
          destroyOnClose={true}
          style={{ overflow: 'auto' }}
        >
          {/* <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{ flex: 1, overflowY: 'auto' }}> */}
        
        <Form
          onFinish={handleAddOrEditUser}
          layout="horizontal"
          labelCol={{ span: 8 }}   
          wrapperCol={{ span: 16 }} 
          className="space-y-6"
          form={form}
          initialValues={{active: true,
            documentType: documentTypes,
            documentCategory: documentCategories
          }}
        >
          <div className='flex flex-col gap-3 pb-12'>
          {/* First Name */}
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[{ required: true, message: 'Please enter your first name' }]}
          >
            <Input
              prefix={<FaUser className="text-gray-500" />}
              placeholder="Enter First Name"
             
              style={{ width: '100%' }} 
            />
          </Form.Item>

          {/* Last Name */}
          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[{ required: true, message: 'Please enter your last name' }]}
          >
            <Input
              prefix={<FaUser className="text-gray-500" />}
              placeholder="Enter Last Name"
              
              style={{ width: '100%' }}
            />
          </Form.Item>

          {/* Username */}
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please enter a username' }]}
          >
            <Input
              prefix={<FaUser className="text-gray-500" />}
              placeholder={isEditUser ? "Username cannot be changed" : "Enter Username"}
              style={{ width: '100%' }}
              disabled={isEditUser}
              autoComplete='off'
            />
          </Form.Item>

          {/* Email */}
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, type: 'email', message: 'Please enter a valid email' }]}
          >
            <Input
              prefix={<FaEnvelope className="text-gray-500" />}
              placeholder="Enter Email"
              style={{ width: '100%' }}
            />
          </Form.Item>

          {/* Phone Number */}
          <Form.Item
            label="Phone Number"
            name="phoneNumber"
            rules={[{ required: true, message: 'Please enter your phone number' }]}
          >
            <PhoneInput
              country="om"
              inputProps={{
                name: 'phone',
                required: true,
                className: 'w-full p-1.5 pl-12 border border-gray-300 rounded-lg',
              }}
            />
          </Form.Item>

          {/* Password and Confirm Password */}
          {!isEditUser && (
            <>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: 'Please enter a password' }]}
              >
                <Input.Password
                  prefix={<FaLock className="text-gray-500" />}
                  placeholder="Enter Password"
                  style={{ width: '100%' }}
                  autoComplete="new-password"
                />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="confirmPassword"
                rules={[{ required: true, message: 'Please confirm your password' }]}
              >
                <Input.Password
                  prefix={<FaLock className="text-gray-500" />}
                  placeholder="Confirm Password"
                  style={{ width: '100%' }}
                />
              </Form.Item>

              {passwordError && <p className="text-red-500 text-sm">{passwordError}</p>}
              {confirmPasswordError && <p className="text-red-500 text-sm">{confirmPasswordError}</p>}
            </>
          )}

          <Form.Item name="userType" label="User Type" rules={[{ required: true, message: "Please select a document category." }]}> 
            <Select 
              placeholder="Select Document Category"
              onChange={(value) => {
                setSelectedUserType(value);
                form.setFieldsValue({ role: [] }); // reset role when userType changes
                setSelectedRole([]);
              }}
            >
              <Option key={CONTRACTOR} value={CONTRACTOR}>{CONTRACTOR}</Option>
              <Option key={CONSULTANT} value={CONSULTANT}>{CONSULTANT}</Option>
              <Option key={EMPLOYER} value={EMPLOYER}>{EMPLOYER}</Option>
              <Option key={SUBCONTRACTOR} value={SUBCONTRACTOR}>{SUBCONTRACTOR}</Option>
              <Option key={NOMINATED_SUBCONTRACTOR} value={NOMINATED_SUBCONTRACTOR}>{NOMINATED_SUBCONTRACTOR}</Option>
              <Option key={SPECIALIST_SUBCONTRACTOR} value={SPECIALIST_SUBCONTRACTOR}>{SPECIALIST_SUBCONTRACTOR}</Option>
              <Option key={VENDOR} value={VENDOR}>{VENDOR}</Option>
              <Option key={PROJECT_MANAGEMENT_CONSULTANT} value={PROJECT_MANAGEMENT_CONSULTANT}>{PROJECT_MANAGEMENT_CONSULTANT}</Option>
            </Select>
          </Form.Item>

          {/* Roles */}
          <Form.Item
            label="Role"
            name="role"
            rules={[{ required: true, message: 'Please select at least one role' }]}
          >
            <Select
              mode="multiple"
              placeholder={
                selectedUserType
                  ? "Select Role"
                  : "Select User Type first"
              }
              disabled={!selectedUserType}
              style={{ width: '100%' }}
              onChange={(value) => setSelectedRole(value)}
            >
              {filteredRoles.map((roleObj) => (
                <Option key={roleObj.code} value={roleObj.role}>
                  {roleObj.role}
                </Option>
              ))}
            </Select>
          </Form.Item>
          

          <Form.Item name="documentType" label="Document Type" rules={[{ required: true, message: "Please select a document type." }]}> 
            <Select placeholder="Select Document Type" mode='multiple'>
              {documentTypes?.map((doc) => (
                <Option key={doc} value={doc}>{doc}</Option>
              ))}
            </Select>
          </Form.Item>
      
          <Form.Item name="documentCategory" label="Document Category" rules={[{ required: true, message: "Please select a document category." }]}> 
            <Select placeholder="Select Document Category" mode='multiple'>
              {documentCategories?.map((category) => (
                <Option key={category} value={category}>{category}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="projectName" label="Project(s)" rules={[{ required: true, message: "Please select at least one project." }]}> 
            <Select mode="multiple" placeholder="Select Project">
              {
                projectNames.map((e) => (
                  <Option value={e}>{e}</Option>    
                ))
              }
            </Select> 
          </Form.Item>
          {/* Permissions */}
          {/* <Form.Item
            label="Permissions"
            wrapperCol={{ span: 24 }}
          >
            <Form.Item
              name="canUploadDocuments"
              valuePropName="checked"
              noStyle
            >
              <Checkbox>Can Upload Documents</Checkbox>
            </Form.Item>
            <Form.Item
              name="canViewDocuments"
              valuePropName="checked"
              noStyle
            >
              <Checkbox>Can View Documents</Checkbox>
            </Form.Item>
          </Form.Item> */}
          </div>

          <div
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right'
          }}
          className='flex flex-row justify-end'
        >

          <Form.Item >
           <Space style={{ paddingLeft: '16px' }}>
              <Button onClick={handleCloseDrawer}>Cancel</Button>
              <Button type="primary" htmlType="submit">
              {editingUser ? 'Update User' : 'Add User'}
             </Button>
           </Space>
          </Form.Item>
          </div>
        </Form>
        {/* </div>
        </div> */}
        </Drawer>
      </div>
    </div>
  );
};

export default ManageUsers;